import React, { useState } from "react";
import myimg from "./footerimg/original-9551c73edd32f9c2a822af1d1b7ea7b5.gif";
const PartnershipSection = () => {
  // Form Success Message Handler
  const [sent, setSent] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 3500);
  };

  return (
    <div className="container" >
      {/* 1️⃣ About Section */}
      <section id="about" className="about section bg-white py-5">
        <div className="container">
          <div className="row gy-4 align-items-center justify-content-between py-5 pl-2">
            {/* Left Column */}
            <div className="col-xl-5 text-dark">
              <span
                className="about-meta fw-semibold mb-2 d-block"
                style={{ color: "#198754", letterSpacing: ".04em" }}
              >
                PARTNER WITH US
              </span>
              <h2 className="about-title mb-3 text-dark">
                Join Us in Transforming Healthcare
              </h2>
              <p className="about-description mb-4 text-dark">
                Log e Infotech stands at the forefront of healthcare technology, delivering innovative solutions to hospitals, laboratories, and clinics globally. As we broaden our presence in the international market, we are actively pursuing strategic alliances with businesses and individuals who can link us to healthcare institutions aiming to enhance their operations. By collaborating with Log e Infotech, you will have the chance to participate in a worldwide initiative to optimize healthcare operations, elevate patient care, and propel digital transformation within healthcare facilities.
              </p>
              {/* Feature List */}
              <div className="row feature-list-wrapper">
                <div className="col-md-6">
                  <ul className="list-unstyled feature-list mb-0">
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Thorough Product Training
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      White Labeling Opportunities
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul className="list-unstyled feature-list mb-0">
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Marketing & Sales Support
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Partnership Manager
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Right Column */}
            <div className="col-xl-6 text-center text-xl-end">
              <div className="image-wrapper position-relative">
                <img
                  alt="Business Meeting"
                  className="img-fluid main-image rounded-4"
                  src={myimg}
                  style={{ width: "100%", maxWidth: "580px", height: "auto" }}
                />
                {/* <div
                  className="experience-badge floating bg-white shadow rounded-pill py-2 px-4 position-absolute"
                  style={{ top: "30px", left: "30px" }}
                >
                  <h3 className="mb-0" style={{ color: "#198754", fontWeight: 700 }}>
                    15+ <span style={{ fontWeight: 400 }}>Years</span>
                  </h3>
                  <p className="mb-0 text-dark small">Of experience in business service</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2️⃣ Services Section */}
      <section id="services" className="services section py-5 light-background" style={{ backgroundColor: "#f3f9ff" }}>
        <div className="container section-title text-center text-dark mb-4">
          <h2 className="mb-3 text-dark">
            What are the benefits of partnering with Log e Infotech Pvt. Ltd.?
          </h2>
          <p className="mb-4 text-dark">
            Our team is committed to providing you with marketing resources, sales support, and promotional initiatives customized for your market.
          </p>
        </div>
        <div className="container">
          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-lg-6 d-flex">
              <div className="service-card d-flex align-items-start bg-white rounded p-3 gap-3 text-dark flex-grow-1 shadow">
                <div className="icon flex-shrink-0 fs-1 text-success">
                  <i className="bi bi-activity"></i>
                </div>
                <div>
                  <h3 className="mb-2 text-dark">Demonstrated History of Success</h3>
                  <p className="mb-0 text-dark">
                    Log e Infotech has established a presence in multiple countries and has earned the trust of hospitals, laboratories, and clinics for more than ten years. Our solutions are tailored to address the requirements of contemporary healthcare organizations, emphasizing efficiency, compliance, and a patient-centered approach.
                  </p>
                </div>
              </div>
            </div>
            {/* Card 2 */}
            <div className="col-lg-6 d-flex">
              <div className="service-card d-flex align-items-start bg-white rounded p-3 gap-3 text-dark flex-grow-1 shadow">
                <div className="icon flex-shrink-0 fs-1 text-success">
                  <i className="bi bi-diagram-3"></i>
                </div>
                <div>
                  <h3 className="mb-2 text-dark">Revenue and Expansion Prospects</h3>
                  <p className="mb-0 text-dark">
                    Collaborating with Log e Infotech presents a distinctive chance to lead in the transformation of healthcare, fostering innovation and improved patient care. By partnering with our reputable brand, you can propel substantial growth for your business, generating value for both your clients and your organization.
                  </p>
                </div>
              </div>
            </div>
            {/* Card 3 */}
            <div className="col-lg-6 d-flex">
              <div className="service-card d-flex align-items-start bg-white rounded p-3 gap-3 text-dark flex-grow-1 shadow">
                <div className="icon flex-shrink-0 fs-1 text-success">
                  <i className="bi bi-easel"></i>
                </div>
                <div>
                  <h3 className="mb-2 text-dark">Concentrated on Global Markets</h3>
                  <p className="mb-0 text-dark">
                    As we concentrate on broadening our presence in international markets, we seek to partner with those who comprehend the distinct requirements of healthcare providers in these areas. By leveraging your local knowledge and connections, we can achieve a more significant impact collectively.
                  </p>
                </div>
              </div>
            </div>
            {/* Card 4 */}
            <div className="col-lg-6 d-flex">
              <div className="service-card d-flex align-items-start bg-white rounded p-3 gap-3 text-dark flex-grow-1 shadow">
                <div className="icon flex-shrink-0 fs-1 text-success">
                  <i className="bi bi-clipboard-data"></i>
                </div>
                <div>
                  <h3 className="mb-2 text-dark">Cutting-edge Healthcare Solutions</h3>
                  <p className="mb-0 text-dark">
                    Log e Infotech provides a range of comprehensive products, such as Hospital ERP-HMS, Laboratory Information Systems (LIS), and management systems for allopathic, Ayurvedic, and Homeopathic pharmacies, designed to fulfill the requirements of any healthcare environment. Our cloud-based solutions guarantee that healthcare professionals can securely access data at any time and from any location.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3️⃣ Contact/Partnership Section */}
      <section id="contact" className="contact section light-background py-5" style={{ backgroundColor: "#f3f9ff" }}>
        <div className="container section-title text-dark mb-4">
          <h2 className="text-dark mb-3">How to Establish a Partnership with Log e Infotech</h2>
          <p className="text-dark mb-0">
            Are you interested in collaborating with Log e Infotech? Please complete the form below, and we will reach out to discuss potential avenues for cooperation. We seek partners who can offer hospital and laboratory references, emphasizing the development of long-lasting, mutually advantageous relationships.
          </p>
        </div>
        <div className="container">
          <div className="row g-4 g-lg-5">
            {/* Left Column: Contact Info */}
            <div className="col-lg-5">
              <div className="info-box bg-white p-4 rounded shadow-sm text-dark h-100 d-flex flex-column">
                <h3 className="mb-3 text-dark">Partner with Us</h3>
                <p className="mb-4 text-dark">Regardless of whether you are an industry consultant, a technology provider, or a healthcare influencer, we invite you to become a part of our network and help introduce healthcare providers to the future of healthcare management.</p>
                <div className="info-item d-flex align-items-start mb-3">
                  <div className="icon-box text-success fs-3 me-3">
                    <i className="bi bi-house"></i>
                  </div>
                  <div>
                    <h5 className="mb-1 text-dark">Company</h5>
                    <p className="mb-0 text-dark">Log e infotech Pvt. Ltd.</p>
                  </div>
                </div>
                <div className="info-item d-flex align-items-start mb-3">
                  <div className="icon-box text-success fs-3 me-3">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div>
                    <h5 className="mb-1 text-dark">Our Location</h5>
                    <p className="mb-0 text-dark">Shop no. 18, Srno- 81/1, bandal capital,</p>
                    <p className="mb-0 text-dark">Near Kothrud depo, paud road, Kothrud,</p>
                    <p className="mb-0 text-dark">India - MH - Pune - 411038</p>
                  </div>
                </div>
                <div className="info-item d-flex align-items-start mb-3">
                  <div className="icon-box text-success fs-3 me-3">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div>
                    <h5 className="mb-1 text-dark">Phone Number</h5>
                    <p className="mb-0 text-dark">+91 7773967002</p>
                    <p className="mb-0 text-dark">+91 7028287002</p>
                  </div>
                </div>
                <div className="info-item d-flex align-items-start">
                  <div className="icon-box text-success fs-3 me-3">
                    <i className="bi bi-envelope"></i>
                  </div>
                  <div>
                    <h5 className="mb-1 text-dark">Email Address</h5>
                    <p className="mb-0 text-dark">info@logesolutions.net</p>
                    <p className="mb-0 text-dark">contact@logesolutions.net</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Column: Contact Form */}
            <div className="col-lg-7">
              <div className="contact-form bg-white p-4 rounded shadow-sm text-dark h-100">
                <h3 className="mb-3 text-dark">Get In Touch</h3>
                <p className="mb-4 text-dark">
                  We invite you to become a part of our network and help introduce healthcare providers to the future of healthcare management.
                </p>
                <form className="php-email-form" onSubmit={handleSubmit}>
                  <div className="row gy-4">
                    <div className="col-md-6">
                      <input type="text" name="name" className="form-control" placeholder="Your Name" required />
                    </div>
                    <div className="col-md-6">
                      <input type="email" name="email" className="form-control" placeholder="Your Email" required />
                    </div>
                    <div className="col-12">
                      <input type="text" name="subject" className="form-control" placeholder="Subject" required />
                    </div>
                    <div className="col-12">
                      <textarea name="message" rows="6" className="form-control" placeholder="Message" required></textarea>
                    </div>
                    <div className="col-12 text-center">
                      {sent && (
                        <div className="alert alert-success py-2 mb-2" role="alert">
                          Your message has been sent. Thank you!
                        </div>
                      )}
                      <button type="submit" className="btn btn-success mt-2">Send Message</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartnershipSection;
